"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPackshotProperty = exports.packshotPropertyDefinition = void 0;
exports.packshotPropertyDefinition = {
    name: 'packshot',
    type: 'asset',
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'stencils',
            argument: ['image'],
        },
    ],
    multiple: false,
    view: {
        label: 'Packshot',
        style: 'media-preview',
        hint: 'Used for Energy Drink and Organics promotion type to represent the product itself.',
    },
};
const isPackshotProperty = (prop) => {
    return prop.name === exports.packshotPropertyDefinition.name;
};
exports.isPackshotProperty = isPackshotProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFja3Nob3QucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9wYWNrc2hvdC5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLDBCQUEwQixHQUFHO0lBQ3hDLElBQUksRUFBRSxVQUFVO0lBQ2hCLElBQUksRUFBRSxPQUFPO0lBQ2IsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUUsSUFBSTtTQUNmO1FBQ0Q7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUUsQ0FBQyxPQUFPLENBQUM7U0FDcEI7S0FDRjtJQUNELFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLFVBQVU7UUFDakIsS0FBSyxFQUFFLGVBQWU7UUFDdEIsSUFBSSxFQUFFLG9GQUFvRjtLQUMzRjtDQUM4QixDQUFBO0FBSTFCLE1BQU0sa0JBQWtCLEdBQUcsQ0FBQyxJQUFrQixFQUE0QixFQUFFO0lBQ2pGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxrQ0FBMEIsQ0FBQyxJQUFJLENBQUE7QUFDdEQsQ0FBQyxDQUFBO0FBRlksUUFBQSxrQkFBa0Isc0JBRTlCIn0=